import React from 'react';
import { ArrowRight, Layers } from 'lucide-react';
import { LEVEL_LABELS, PathwayTemplate } from '../../types/pathway';
import { formatHours, totalHours } from '../../utils/pathwayMatching';
interface ProvenPathwaysProps {
  templates: PathwayTemplate[];
  onUseTemplate: (template: PathwayTemplate) => void;
}

/**
 * Pre-built sequences anyone can start from. Deliberately kept outside the
 * saved-pathways folder so removing that feature leaves these intact.
 */
export function ProvenPathways({
  templates,
  onUseTemplate
}: ProvenPathwaysProps) {
  return <section aria-labelledby="proven-pathways-heading" className="mt-10" data-id="element-1737" data-mp="1jt0ivrg9lcgq">
      <div className="mb-4" data-id="element-1738" data-mp="1es2yd87s86c2">
        <h2 id="proven-pathways-heading" className="text-xl font-bold text-gray-900" data-id="element-1739" data-mp="19sgc699z7fr4">
          Proven pathways
        </h2>
        <p className="mt-1 max-w-xl text-sm text-gray-600" data-id="element-1740" data-mp="3949f0mjg3fbr">
          Pre-built sequences your team already sells. Start from one and edit
          it for your prospect.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2" data-id="element-1741" data-mp="kj35m20t90so">
        {templates.map(template => <button key={template.id} type="button" onClick={() => onUseTemplate(template)} className="group flex h-full flex-col rounded-xl border border-gray-100 bg-white p-5 text-left shadow-sm transition-shadow hover:shadow-md" data-id="element-1742" data-mp="omiz4phl2l15">
            <div className="flex items-center gap-3" data-id="element-1743" data-mp="13a43emq72qan">
              <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-[#30718D]/10" data-id="element-1744" data-mp="13cqa6k59h1rt">
                <Layers size={16} className="text-[#30718D]" data-id="element-1745" data-mp="tkkmhmm1l6if" />
              </span>
              <h3 className="text-base font-semibold text-gray-900" data-id="element-1746" data-mp="tiq7sq1d6ams">
                {template.name}
              </h3>
            </div>
            <p className="mt-3 flex-grow text-sm text-gray-600" data-id="element-1747" data-mp="1m8yhrulqxoqa">
              {template.summary}
            </p>
            <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-3" data-id="element-1748" data-mp="1r1009y9icbor">
              <span className="text-xs text-gray-500" data-id="element-1749" data-mp="20uvvteg47kk4">
                {template.moduleIds.length} modules ·{' '}
                {formatHours(totalHours(template.moduleIds))} ·{' '}
                {LEVEL_LABELS[template.audience]}
              </span>
              <span className="flex items-center gap-1 text-sm font-medium text-[#DB3725]" data-id="element-1750" data-mp="1mw5z3zx7jmwa">
                Use
                <ArrowRight size={14} className="transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-1751" data-mp="1hwt2ingjb1gi" />
              </span>
            </div>
          </button>)}
      </div>
    </section>;
}